@if (scriptStatus.error) {
  <span class="col-2"
  >{{scriptStatus.error}}</span>
}